import { Button, Tooltip } from 'antd';
import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';

// Define the ExportCSVReport component
const ExportCSVReport = ({ elements, reportName, label }) => {
  // Define column headers for CSV

  const dataArray = Array.isArray(elements) ? elements : [elements];

  const fileHeaders = Object.keys(dataArray[0]);

  // Function to convert JSON to CSV string
  function convertJSONToCSV(jsonData: any[], columnHeaders: string[]) {
    // Check if JSON data is empty
    if (jsonData.length === 0) {
      return '';
    }

    // Create headers string
    const headers = '\uFEFF' + columnHeaders.join(',') + '\n';

    // Map JSON data to CSV rows
    const rows =
      '\uFEFF' +
      jsonData
        .map((row: { [x: string]: any }) => {
          // Map each row to CSV format
          return columnHeaders
            .map((field: string | number) => row[field] || '')
            .join(',');
        })
        .join('\n');
    // Combine headers and rows
    return headers + rows;
  }

  // Function to initiate CSV download
  function downloadCSV(jsonData: any[], headers: string[]) {
    const csvData = convertJSONToCSV(jsonData, headers);

    // Check if CSV data is empty
    if (csvData === '') {
      alert('No data to export');
    } else {
      // Create CSV file and initiate download
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `${reportName}-report.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  // Render the button for CSV export
  return (
    <Tooltip title={'Export Report'}>
      <Button
        type='default'
        icon={<DownloadOutlined />}
        className={`EditBtn ${!label && `iconBtn`}`}
        onClick={() => downloadCSV(dataArray, fileHeaders)}
      >
        {label ? `Export` : ``}
      </Button>
    </Tooltip>
  );
};

export default ExportCSVReport;
